module.exports = __webpack_public_path__ + "img/hobbyshop_title.07e1cf8f.png";